import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import DatePicker from "../../components/DatePicker.jsx";
import {
  getAvailableSlots,
  setDateTimeShowCalendar,
  setCurrentlyOpenDateDropdown,
} from "../../store/scheduler.js";
import CalendarPicker from "react-datepicker";
import { useEffect, useMemo } from "react";
import { ReactComponent as IconWeek } from "../../assets/icons/icons-week.svg";
import TagManager from "react-gtm-module";

import "./CalendarView.css";

// TODO: Add year to month title

export default function CalendarView() {
  const dispatch = useDispatch();
  const { franchiseSlots, slotsLoading } = useSelector(
    (state) => state.scheduler
  );
  const currentlyOpenDateDropdown = useSelector(
    (state) => state.scheduler.currentlyOpenDateDropdown
  );
  const selected = currentlyOpenDateDropdown
    ? dayjs(currentlyOpenDateDropdown).toDate()
    : dayjs().toDate();

  const handleGADatepickerEvent = () => {
    const dataLayer = {
      event: "event_week_view_clicked",
    };

    TagManager.dataLayer({
      dataLayer,
    });
  };

  const changeView = (e) => {
    e.preventDefault();
    handleGADatepickerEvent();
    dispatch(setDateTimeShowCalendar(false));
  };

  const getFranchiseSlot = useMemo(() => {
    const key = currentlyOpenDateDropdown || Object.keys(franchiseSlots)[0];
    const slotData = franchiseSlots[key];
    if (!slotData) return null;
    return { ...slotData, key };
  }, [franchiseSlots, currentlyOpenDateDropdown]);

  // User selected date on calendar
  const getNewDate = (date) => {
    const newDate = dayjs(date);
    const dateKey = newDate.format("YYYY-MM-DD");

    // Only fetch if this date isn't already in franchiseSlots; fetch 7 days
    // so WeekView also has a full week if the user switches back
    if (!franchiseSlots[dateKey]) {
      dispatch(getAvailableSlots(newDate));
    }

    dispatch(setCurrentlyOpenDateDropdown(dateKey));
  };

  // Determines whether or not previous button should appear
  const showPrevButton = () => {
    if (!currentlyOpenDateDropdown) return false;
    const selectedDayjs = dayjs(currentlyOpenDateDropdown);
    if (!selectedDayjs.isValid()) return false;
    return selectedDayjs.format("YYYY-MM-DD") !== dayjs().format("YYYY-MM-DD");
  };

  const handlePrevClicked = (e) => {
    e.preventDefault();
    const currentDate = dayjs(currentlyOpenDateDropdown);
    if (!currentDate.isValid()) return;
    const prevDate = currentDate.subtract(1, "day");

    getNewDate(prevDate);
  };

  const handleNextClicked = (e) => {
    e.preventDefault();
    const currentDate = dayjs(currentlyOpenDateDropdown);
    if (!currentDate.isValid()) return;
    const nextDate = currentDate.add(1, "day");

    getNewDate(nextDate);
  };

  //* Component Did Mount
  useEffect(() => {
    const dateKey = currentlyOpenDateDropdown || dayjs().format("YYYY-MM-DD");
    if (!franchiseSlots[dateKey]) {
      dispatch(getAvailableSlots(selected));
    }
    if (!currentlyOpenDateDropdown) {
      dispatch(setCurrentlyOpenDateDropdown(dayjs().format("YYYY-MM-DD")));
    }
  }, []);

  // Recovery: if franchiseSlots is overwritten by a background fetch (e.g. AppointmentTypeSelector
  // re-fetching today's week on back-navigation) and the current date is no longer present, re-fetch.
  useEffect(() => {
    if (!currentlyOpenDateDropdown || slotsLoading) return;
    if (!franchiseSlots[currentlyOpenDateDropdown]) {
      dispatch(getAvailableSlots(dayjs(currentlyOpenDateDropdown)));
    }
  }, [franchiseSlots]);

  return (
    <div className="calendarview">
      <button className="datetime-button-link" onClick={changeView}>
        <IconWeek />
        Week view
      </button>
      <div className="calendarview-container">
        <div>
          <CalendarPicker
            selected={selected}
            onChange={getNewDate}
            inline
            dateFormatCalendar={"LLLL yyyy"}
            minDate={dayjs().toDate()}
          />
        </div>
        <div className="calendarview-datepicker">
          {slotsLoading && !getFranchiseSlot ? (
            <p className="weekview-loading">Loading available times...</p>
          ) : (
            getFranchiseSlot && (
              <DatePicker data={getFranchiseSlot} alwaysOpen />
            )
          )}
          <div className="calendarview-navbuttons">
            {showPrevButton() && (
              <button onClick={handlePrevClicked}>Prev day</button>
            )}
            <button
              onClick={handleNextClicked}
              className="calendarview-nextday"
            >
              Next day
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
